import AppLogo from './AppLogo.container';

export default AppLogo;
